<template>
	<v-list class="mention-bar">
		<div class="mention-bar__progress d-flex justify-center align-center" v-if="isLoading">
			<v-progress-circular indeterminate :size="25" :width="3"></v-progress-circular>
		</div>
		<div
			v-else-if="attendees.length"
			v-for="user in attendees.slice(0, 3)"
			:key="user.user_id"
			@click="handleClick(user)"
		>
			<div class="mention-bar__list">
				<Avatar borderRadius="square" :size="40" :avatar="user.user_logo" />
				<div class="d-flex flex-column ml-3">
					<span class="mention-bar__user-name">
						{{ user.visible_username }}
					</span>
				</div>
			</div>
		</div>
		<p v-else class="d-flex justify-center" style="font-size: 16px">No matching users</p>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'

const DEBOUNCE_TIMEOUT = 500

export default {
	components: {
		Avatar,
	},
	props: {
		searchString: {
			type: String,
			default: '',
		},
		mentions: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),

		handleClick(user) {
			this.$emit('setMention', user)
		},
	},
	computed: {
		...mapGetters('event', ['isLoading', 'attendees']),
	},
	watch: {
		searchString: {
			handler(newVal, oldVal) {
				if (newVal === oldVal) return
				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					this.getAttendeesEvent(`?page=1&search=${newVal}`)
				}, DEBOUNCE_TIMEOUT)
			},
		},
	},
	created() {
		this.getAttendeesEvent(`?page=${1}`)
	},
	beforeDestroy() {
		this.clearAttendeesEvent()
	},
}
</script>

<style lang="scss">
.mention-bar {
	position: absolute;
	left: 0;
	bottom: 65px;
	max-width: 555px !important;
	width: 100%;
	max-height: 210px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 12px;
	border-radius: 8px 8px 0 0 !important;
	padding: 12px;
	border-bottom: 1px solid #e2e2e2 !important;
	box-shadow: 0 -6px 8px 0 #00000014 !important;

	@media (max-width: 768px) {
		max-width: none !important;
		overflow: auto;
	}

	&__list {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__user {
		&-name {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--primary_color);
		}

		&-company {
			font-size: 13px;
			color: #697583;
			line-height: 19px;
		}
	}
}
</style>
